import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import GetPlayersReportRequest from '@/api/players-report/get-players-report.request';
import { Ref } from 'vue';

export class PlayersReportApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  public get getPlayersReportRequest(): GetPlayersReportRequest {
    return new GetPlayersReportRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }
}
